import themes from './themes';

/**
 *
 * @returns {Array<{ id: string, title: string }>} An array of available theme.
 */
export default function getAvailableThemes() {
    return Object.keys(themes)
        .filter(key => key !== 'default')
        .map(key => ({ id: key, title: themes[key].displayName }));
}
